var parallax_scroll_top = [];
jQuery(document).ready(function() {
    "use strict";
    var $ = jQuery;
	var $jora_content = $('.jora-content');
	var $menu_toggler = $('.menu-toggler');

	$menu_toggler.css({
		'top': $menu_toggler.offset().top,
		'right': $jora_content.width() - $menu_toggler.offset().left - $menu_toggler.width()
	}).addClass('is-fixed-position');

	$(document).on('mousemove', '.portfolio-post-preview.with-image', function(event){
		// var $item = $(this);
		var $item = $(this).find('.ppp-wrapper');
		var item_offset = $item.offset(),
			x = event.pageX - item_offset.left,
			y = event.pageY - item_offset.top,
			vw = x/$item.parent().width()*10,
			vh = y/$item.parent().height()*10;

		if (vw > 5 && vh < 5) {
			prefix($item.find('.ppp-border'), 'transform', 'translate('+(vw-5)*2+'px, '+vh+'px)');
			prefix($item.find('.ppp-image'), 'transform', 'translate('+(5-vw)*2+'px,-'+vh+'px)');
		} else if (vw > 5 && vh > 5) {
			prefix($item.find('.ppp-border'), 'transform', 'translate('+(vw-5)*2+'px, '+vh+'px)')
			prefix($item.find('.ppp-image'), 'transform', 'translate('+(5-vw)*2+'px,-'+vh+'px)');;
		} else if (vw < 5 && vh < 5) {
			prefix($item.find('.ppp-border'), 'transform', 'translate(-'+(5-vw)*2+'px, '+vh+'px)');
			prefix($item.find('.ppp-image'), 'transform', 'translate('+(5-vw)*2+'px,-'+vh+'px)');
		} else {
			prefix($item.find('.ppp-border'), 'transform', 'translate(-'+(5-vw)*2+'px, '+vh+'px)');
			prefix($item.find('.ppp-image'), 'transform', 'translate('+(5-vw)*2+'px,-'+vh+'px)');
		}
	});

	$(document).on('mousemove', '.jora-homepage-featured', function(event){
		var $item = $(this);
		// var $item = $(this).find('.ppp-wrapper');
		var item_offset = $item.offset(),
			x = event.pageX - item_offset.left,
			y = event.pageY - item_offset.top,
			vw = x/$item.parent().width()*10,
			vh = y/$item.parent().height()*10;

		if (vw > 5 && vh < 5) {
			prefix($item.find('.border-before'), 'transform', 'translate('+(vw-5)*10+'px, '+vh*10+'px)');
			prefix($item.find('.border-after'), 'transform', 'translate('+(5-vw)*10+'px,-'+vh*10+'px)');
		} else if (vw > 5 && vh > 5) {
			prefix($item.find('.border-before'), 'transform', 'translate('+(vw-5)*10+'px, '+vh*10+'px)')
			prefix($item.find('.border-after'), 'transform', 'translate('+(5-vw)*10+'px,-'+vh*10+'px)');;
		} else if (vw < 5 && vh < 5) {
			prefix($item.find('.border-before'), 'transform', 'translate(-'+(5-vw)*10+'px, '+vh*10+'px)');
			prefix($item.find('.border-after'), 'transform', 'translate('+(5-vw)*10+'px,-'+vh*10+'px)');
		} else {
			prefix($item.find('.border-before'), 'transform', 'translate(-'+(5-vw)*10+'px, '+vh*10+'px)');
			prefix($item.find('.border-after'), 'transform', 'translate('+(5-vw)*10+'px,-'+vh*10+'px)');
		}
	});

	$(document).on('mouseleave', '.portfolio-post-preview.with-image', function(event){
		// var $item = $(this);
		var $item = $(this).find('.ppp-wrapper');

		prefix($item.find('.ppp-border'), 'transform', 'translate(0, 0)');
		prefix($item.find('.ppp-image'), 'transform', 'translate(0, 15px)');
	});

	$('.portfolio-archive-grid').masonry({
		itemSelector: '.portfolio-post-preview',
		columnWidth: '.portfolio-post-preview',
		percentPosition: true
	});

	$(document).on('click', '.menu-toggler a', function (e){
		e.preventDefault();
		if ($jora_content.hasClass('menu-is-visible')) {
			$jora_content.removeClass('menu-is-visible');
		} else {
			$jora_content.addClass('menu-is-visible');
		}
	})

	var $parallax_el = $('.jora-homepage-parallax-image');
	if ($parallax_el.length) {
		$parallax_el.each(function(i,v){
			var $el = $($parallax_el[i]);
			parallax_scroll_top['ai_'+i] = $el.offset().top;
			$(window).on('scroll', function() {
				apply_parallax_effect($el, i);
			});
		})
	}

	var $parallax_portfolio = $('.jora-portfolio-bg-image');
	if ($parallax_portfolio.length) {
		$(window).on('scroll', function() {
			var scrolled_height = $(window).scrollTop(),
			all_height = $(window).height(),
			parallax_position = scrolled_height * 100 / all_height;
			window.requestAnimationFrame(function () {
		        $parallax_portfolio.css({
		          	'webkitTransform': 'translateY(' + parallax_position * 2 + 'px)',
					'MozTransform': 'translateY(' + parallax_position * 2 + 'px)',
					'msTransform': 'translateY(' + parallax_position * 2 + 'px)',
					'OTransform': 'translateY(' + parallax_position * 2 + 'px)',
					'transform': 'translateY(' + parallax_position * 2 + 'px)',
		        });
			})
		});
	}

})

jQuery(window).resize(function(){
	var $ = jQuery;
	var $jora_content = $('.jora-content');
	var $menu_toggler = $('.menu-toggler');

	$menu_toggler.attr('style', '').removeClass('is-fixed-position');

	$menu_toggler.css({
		'top': $menu_toggler.offset().top,
		'right': $jora_content.width() - $menu_toggler.offset().left - $menu_toggler.width()
	}).addClass('is-fixed-position');
})

function apply_parallax_effect($parallax_el, index){
	var $ = jQuery;
	if (!parallax_scroll_top['ai_'+index]) {
		parallax_scroll_top['ai_'+index] = 0;
	}
	var scrolledHeight = $(window).scrollTop(),
	limit = $parallax_el.offset().top + $parallax_el.height() + parseInt($parallax_el.css('padding-top')) + parseInt($parallax_el.css('padding-bottom'));
	window.requestAnimationFrame(function () {
		if (scrolledHeight > parallax_scroll_top['ai_'+index] - $(window).height() && scrolledHeight <= limit) {
			var total_px = limit - parallax_scroll_top['ai_'+index] + $(window).height();
			var current_px = limit - scrolledHeight;
			var scrolled = total_px - current_px;
	        $parallax_el.css({
	          	'webkitTransform': 'translateY(' + scrolled * 0.2 + 'px, 0)',
				'MozTransform': 'translateY(' + scrolled * 0.2 + 'px)',
				'msTransform': 'translateY(' + scrolled * 0.2 + 'px)',
				'OTransform': 'translateY(' + scrolled * 0.2 + 'px)',
				'transform': 'translateY(' + scrolled * 0.2 + 'px)',
	        });
		}
	})
}

function prefix(element, property, value){

    var pre = ['-webkit-',
               '-moz-',
               '-ms-',
               '-o-',
               ''];

    for(var i = 0 ; i < pre.length ; i++){
        element.css(pre[i] + property, value);
    }
};
